// extracted by mini-css-extract-plugin
module.exports = {"carouselButton":"CarouselNavButton_carouselButton__4STy_","accent":"CarouselNavButton_accent__zE40l","light":"CarouselNavButton_light__5kmhd"};